module.exports = __webpack_public_path__ + "static/blazor-0b3b740c2e3d35845ba519ae7a4dec7e.png";